import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getNavigationalWindowObject } from '../../../../AppUtil/AppUtil';
import Session from '../../../../Service/Session';
import LanguageSelector from './LanguageSelector';
import NavLink from './NavLink';
import NotificationBadge from './NotificationBadge';

const CONTACT = window.AppConfig.SUPPORT_URLS;
const USER_TYPE = window.AppConfig.USER_TYPES;

const clearLoanObject = () => {
	if (!getNavigationalWindowObject()) {
		Session.remove('LOAN_OBJECT');
	}
};

export default function Nav(props) {
	const { t } = useTranslation(['Nav']);

	const current_user_info = Session.get('CURRENT_USER_INFO');

	const hasAccessToAdmin = current_user_info?.profile?.user_type !== USER_TYPE.NORMAL_USER;

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		// Update window width when the window is resized
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			// Remove the event listener when the component unmounts
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const CollapsableNav = () => {
		let selectValue = '';
		let navLinks = [];
		let navComponents = [];

		useEffect(() => {
			// Handle initial selection when the component mounts
			if (selectValue === 'HELP') {
				window.open(CONTACT.LENDAMI_CONTACT, '_blank');
			}
		}, [selectValue]);

		if (props.currentUser) {
			navLinks.push('START A LOAN', 'PROFILE', 'DASHBOARD', 'HELP', 'LOGOUT');
		}
		if (hasAccessToAdmin) {
			navLinks.push('ADMIN');
		}

		let selectElementLinks = 0;
		if (windowWidth >= 901 && windowWidth < 1001) {
			selectElementLinks = 3;
		} else if (windowWidth >= 1001 && windowWidth < 1124) {
			selectElementLinks = 2;
		} else {
			selectElementLinks = 0;
		}

		for (let i = 0; i < navLinks.length - selectElementLinks; i++) {
			navComponents.push(
				<NavLink
					key={navLinks[i]}
					onClick={() => {
						if (navLinks[i] == 'ADMIN') {
							window.location.href = '/admin';
						} else if (navLinks[i] == 'HELP') {
							window.open(CONTACT.LENDAMI_CONTACT, '_blank');
						} else if (navLinks[i] == 'LOGOUT') {
							window.location.href = '/logout';
						} else if (navLinks[i] == 'DASHBOARD') {
							props.openScreen('LOAN_LIST');
						} else {
							if (navLinks[i] == 'START A LOAN') {
								clearLoanObject();
							}
							props.openScreen(navLinks[i].toUpperCase().replace(' ', '_'));
						}
					}}>
					{navLinks[i]}
				</NavLink>
			);
		}

		if (selectElementLinks > 0) {
			let selectOptions = [];
			for (let i = navLinks.length - selectElementLinks; i < navLinks.length; i++) {
				selectOptions.push(
					<option className="nav-select-option" key={navLinks[i]} value={navLinks[i]}>
						{navLinks[i]}
					</option>
				);
			}

			navComponents.push(
				<select
					className="nav-select"
					key="selectElement"
					onChange={e => {
						selectValue = e.target.value;
						if (e.target.value == 'ADMIN') {
							window.location.href = '/admin';
						} else if (e.target.value == 'HELP') {
							window.open(CONTACT.LENDAMI_CONTACT, '_blank');
						} else if (e.target.value == 'LOGOUT') {
							window.location.href = '/logout';
						}
					}}
					value={selectValue}
					style={{ width: selectValue ? 'auto' : '30px', backgroundColor: '' }}>
					<option value="" disabled></option>
					{selectOptions}
				</select>
			);
		}

		return navComponents;
	};

	return (
		<div className="android-navigation-container no-print">
			<nav className="android-navigation mdl-navigation">
				{/* <CollapsableNav /> */}
				{props.currentUser ? (
					<NavLink
						onClick={() => {
							clearLoanObject();
							props.openScreen('HOME');
						}}>
						{t('start_a_loan')}
					</NavLink>
				) : (
					''
				)}
				{/* {props.currentUser ? ' ' : <NavLink onClick={() => props.openScreen('AUTH')}>{t('sign_in')}</NavLink>}  */}
				<NavLink
					onClick={() => {
						clearLoanObject();
						props.openScreen('LOAN_CALCULATOR');
					}}>
					Loan Calculator
				</NavLink>
				{!props.currentUser ? (
					' '
				) : (
					<NavLink onClick={() => props.openScreen('PROFILE')}>{t('profile')}</NavLink>
				)}
				{!props.currentUser ? ' ' : <NavLink onClick={() => props.openScreen('LOAN_LIST')}>DASHBOARD</NavLink>}
				{hasAccessToAdmin && props.currentUser ? (
					<NavLink
						onClick={_e => {
							window.location.href = '/admin';
						}}>
						{t('admin')}
					</NavLink>
				) : (
					''
				)}
				{!props.currentUser ? (
					''
				) : (
					<NavLink
						onClick={() => {
							window.open(CONTACT.LENDAMI_CONTACT, '_blank');
						}}>
						{t('help')}
					</NavLink>
				)}
				{!props.currentUser ? (
					' '
				) : (
					<NavLink
						onClick={_e => {
							window.location.href = '/logout';
						}}>
						{t('logout')}
					</NavLink>
				)}
				{!props.currentUser ? (
					' '
				) : (
					<NotificationBadge
						badgeContent={(() => {
							if (props.notificationCount > 0) {
								return props.notificationCount;
							} else {
								return null;
							}
						})()}
						onClick={props.handleNotificationOpen}
					/>
				)}
				<LanguageSelector currentUser={props.currentUser} setCurrentUser={props.setCurrentUser} />
			</nav>
		</div>
	);
}
